export const MenuLanguages = {
    1: 'GEORGIAN',
    2: 'ENGLISH',
    3: 'RUSSIAN'
}